function removeAfterHideEventHandler(event) {
  const element = event.target
  if(element.tagName.toLowerCase() != "wa-drawer") { return }

  event.currentTarget.remove()
}

class RemoveDrawerOnCloseElement extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if(!this.isConnected){ return }

    this.addEventListener(`wa-after-hide`, removeAfterHideEventHandler)
  }
}

if (!window.customElements.get(`remove-drawer-on-close`)) {
  window.customElements.define(`remove-drawer-on-close`, RemoveDrawerOnCloseElement);
}
